"use client"

import { useState } from "react"
import { useNavigate } from "react-router-dom"
import { 
  Button, 
  Card, 
  CardContent, 
  TextField, 
  FormControl, 
  InputLabel, 
  Select, 
  MenuItem, 
  Box, 
  Typography, 
  Grid, 
  Paper,
  Stepper,
  Step,
  StepLabel,
  IconButton,
  Radio,
  RadioGroup,
  FormControlLabel,
  Checkbox,
  Link,
  CircularProgress
} from "@mui/material"
import { 
  ChevronLeft, 
  ChevronRight, 
  Phone, 
  LocationOn, 
  People, 
  TrendingUp, 
  Description,
  Close,
  DirectionsCar,
  LocalShipping,
  Person,
  Group
} from '@mui/icons-material'
import Map from './Map'
import Img1 from '../img/IMG1.png'
import Img2 from '../img/IMG2.png'
import Img3 from '../img/IMG3.png'
import MainImg from '../img/bg.png'
import NImg from '../img/ga.svg'
import icon1 from '../img/1.svg'
import icon2 from '../img/2.svg'
import icon3 from '../img/3.svg'
import Navbar from "./NavBar"
import { sendStepperFormEmail } from './emailService';
import deadAct from '../img/DeathActive.svg';
import deadinact from '../img/DeathDef.svg';
import MildSerious from '../img/MildSerious.svg';
import MildSeriousDef from '../img/MildDef.svg';
import SeriousDef from '../img/SeriousDef.svg';
import MildDef from '../img/MildDef.svg';
import MildActive from '../img/MildActive.svg';
import carIcon from '../img/CarNew.png';
import truckIcon from '../img/Truck.png';
// Function to get the initial landing URL
let initialLandingUrl = null;
 
const getSourceUrl = () => {
  if (typeof window === "undefined") return "Unknown";
 
  // If we haven't stored the initial URL yet, store it
  if (!initialLandingUrl) {
    initialLandingUrl = window.location.href;
  }
 
  return initialLandingUrl;
};
 
// Function to get IP address
const getIPAddress = async () => {
  try {
    const response = await fetch("https://api.ipify.org?format=json");
    const data = await response.json();
    return data.ip;
  } catch (error) {
    console.error("Failed to get IP address:", error);
    return "IP address not available";
  }
};


// Function to get Form Details
const getFormDetails = () => {
  const path = window.location.pathname; 

  if (path === "/" || path === "") {
    return { formname: "Home Form" };
  }

  const pageKey = path.replace("/", ""); 

  const readable = pageKey
    .replace(/Main$/i, "") 
    .replace(/([a-z])([A-Z])/g, "$1 $2") 
    .trim();

  return { formname: `${readable} Form` };
};
export default function LegalLandingPage() {
  const [showForm, setShowForm] = useState(false)
  const [currentStep, setCurrentStep] = useState(1)
  const [hoveredState, setHoveredState] = useState(null)
  const [isLoading, setIsLoading] = useState(false)
  const [formData, setFormData] = useState({
    // Step 1
    accidentType: "",
    injuryLevel: "",
    // Step 2
    whoWasInAccident: "",
    whoWasAtFault: "",
    // Step 3
    wereYouInsured: "",
    // Step 4
    fullName: "",
    phoneNumber: "",
    email: "",
    consent: false,
    // Step 5
    contactPreference: "",
    // Step 6
    scheduledDate: "",
    scheduledTime: "",
    timezone: ""
  })

  const navigate = useNavigate()

  const handleInputChange = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }))
  }

  const formatPhoneNumber = (value) => {
    // Remove all non-digits
    const phoneNumber = value.replace(/\D/g, '')
    
    // Limit to 10 digits
    if (phoneNumber.length > 10) return formData.phoneNumber
    
    // Format the number
    if (phoneNumber.length === 0) return ''
    if (phoneNumber.length <= 3) return `(${phoneNumber}`
    if (phoneNumber.length <= 6) return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3)}`
    return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3, 6)}-${phoneNumber.slice(6)}`
  }

  const handlePhoneNumberChange = (e) => {
    const formattedNumber = formatPhoneNumber(e.target.value)
    handleInputChange("phoneNumber", formattedNumber)
  }

  const nextStep = () => {
    if (currentStep < 6) {
      // For step 4, send email after moving to step 5
      if (currentStep === 4) {
        handleSubmit().then(() => {
          setCurrentStep(currentStep + 1)
        })
        return
      }
      
      setCurrentStep(currentStep + 1)
    }
  }

  const prevStep = () => {
    if (currentStep > 1) setCurrentStep(currentStep - 1)
  }

  const handleSubmit = async () => {
    console.log("Form submitted:", formData)
    setIsLoading(true)
    
    try {
      // Send email using EmailJS
      const emailResult = await sendStepperFormEmail(formData, "Georgia Landing Page")
        await fetch(
  'https://crm-internal-backend-ayb9fqawg8b6bjen.canadacentral-01.azurewebsites.net/api/submitformdata',
  {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      countryName: 'Usa',
      brandName: 'Personal Injury',
      websiteName: 'Claim4Accidents',
      formname: getFormDetails().formname,
      data: {
        name: formData.fullName,
        email: formData.email,
        phone: formData.phoneNumber,
        accidentType: formData.accidentType,
        injuryLevel: formData.injuryLevel,
        whoWasInAccident: formData.whoWasInAccident,
        whoWasAtFault: formData.whoWasAtFault,
        wereYouInsured: formData.wereYouInsured,
        timezone: formData.timezone,
        scheduledDate: formData.scheduledDate,
        scheduledTime: formData.scheduledTime,
        contactPreference: formData.contactPreference,
        ipAddress: await getIPAddress(),
        submissionDate: new Date().toISOString(),
        pageSource: getSourceUrl(),
      },
    }),
  }
);
      if (emailResult.success) {
        console.log("Email sent successfully")
      } else {
        console.error("Email sending failed:", emailResult.error)
        //alert("Thank you! We'll contact you soon.")
      }
      
      // Handle different contact preferences regardless of API success/failure
      if (formData.contactPreference === "call-now") {
        // For call now, redirect to phone after email attempt
        window.location.href = "tel:8333097030"
        return { success: true }
      } else if (formData.contactPreference === "text-me" || formData.contactPreference === "email-me") {
        // For text/email, go to step 6
        setCurrentStep(6)
        setIsLoading(false)
        return { success: true }
      } else if (formData.contactPreference === "schedule-call") {
        // For schedule call, go to step 6
        setCurrentStep(6)
        setIsLoading(false)
        return { success: true }
      }
      
      // Only reset form and go to step 1 for final submissions
      if (currentStep === 6) {
        //alert("Thank you! We'll contact you soon.")
        setShowForm(false)
        setCurrentStep(1)
        // Reset form data
        setFormData({
          accidentType: "",
          injuryLevel: "",
          whoWasInAccident: "",
          whoWasAtFault: "",
          wereYouInsured: "",
          fullName: "",
          phoneNumber: "",
          email: "",
          consent: false,
          contactPreference: "",
          scheduledDate: "",
          scheduledTime: "",
          timezone: ""
        })
        setIsLoading(false)
        return { success: true }
      }
      
      setIsLoading(false)
      return { success: true }
    } catch (error) {
      console.error("Error submitting form:", error)
      //alert("Thank you! We'll contact you soon.")
      
      // Handle different contact preferences even if API fails
      if (formData.contactPreference === "call-now") {
        // For call now, redirect to phone after email attempt
        window.location.href = "tel:8333097030"
        return { success: true }
      } else if (formData.contactPreference === "text-me" || formData.contactPreference === "email-me") {
        // For text/email, go to step 6
        setCurrentStep(6)
        setIsLoading(false)
        return { success: true }
      } else if (formData.contactPreference === "schedule-call") {
        // For schedule call, go to step 6
        setCurrentStep(6)
        setIsLoading(false)
        return { success: true }
      }
      
      setIsLoading(false)
      return { success: false, error }
    }
  }

  const handlePhoneCall = () => {
    window.location.href = "tel:8333097030"
  }

  const stateData = [
    { id: "CA", name: "California", cities: ["Los Angeles", "San Francisco", "San Diego"], highlighted: true },
    { id: "NV", name: "Nevada", cities: ["Las Vegas", "Reno"], highlighted: true },
    { id: "CO", name: "Colorado", cities: ["Denver", "Colorado Springs"], highlighted: true },
    { id: "TX", name: "Texas", cities: ["Houston", "Dallas", "Austin"], highlighted: false },
    { id: "FL", name: "Florida", cities: ["Miami", "Orlando", "Tampa"], highlighted: false },
    { id: "NY", name: "New York", cities: ["New York City", "Buffalo", "Albany"], highlighted: false },
    { id: "GA", name: "Georgia", cities: ["Atlanta", "Savannah", "Augusta"], highlighted: true }
  ]

  const stats = [
    { number: "300+", label: "Fatalities on I-15", icon: TrendingUp },
    { number: "8K+", label: "Injuries on I-15", icon: Description },
    { number: "150+", label: "Fatalities on I-80", icon: LocationOn },
    { number: "2.5K", label: "Injuries on I-80", icon: People }
  ]

  const steps = ['Accident Type & Injury', 'Accident Details', 'Insurance Information', 'Contact Information', 'Contact Preference', 'Final Step']

  const usTimezones = [
    { value: "America/New_York", label: "Eastern Time (ET)" },
    { value: "America/Chicago", label: "Central Time (CT)" },
    { value: "America/Denver", label: "Mountain Time (MT)" },
    { value: "America/Los_Angeles", label: "Pacific Time (PT)" },
    { value: "America/Anchorage", label: "Alaska Time (AKT)" },
    { value: "Pacific/Honolulu", label: "Hawaii Time (HT)" },
    { value: "America/Phoenix", label: "Arizona Time (MST)" },
    { value: "America/Indiana/Indianapolis", label: "Eastern Time - Indiana" },
    { value: "America/Detroit", label: "Eastern Time - Michigan" },
    { value: "America/Kentucky/Louisville", label: "Eastern Time - Kentucky" },
    { value: "America/Kentucky/Monticello", label: "Eastern Time - Kentucky (Monticello)" },
    { value: "America/Indiana/Vincennes", label: "Eastern Time - Indiana (Vincennes)" },
    { value: "America/Indiana/Winamac", label: "Eastern Time - Indiana (Winamac)" },
    { value: "America/Indiana/Marengo", label: "Eastern Time - Indiana (Marengo)" },
    { value: "America/Indiana/Petersburg", label: "Eastern Time - Indiana (Petersburg)" },
    { value: "America/Indiana/Vevay", label: "Eastern Time - Indiana (Vevay)" },
    { value: "America/Indiana/Tell_City", label: "Central Time - Indiana (Tell City)" },
    { value: "America/Indiana/Knox", label: "Central Time - Indiana (Knox)" },
    { value: "America/Menominee", label: "Central Time - Michigan (Menominee)" },
    { value: "America/North_Dakota/Center", label: "Central Time - North Dakota (Center)" },
    { value: "America/North_Dakota/New_Salem", label: "Central Time - North Dakota (New Salem)" },
    { value: "America/North_Dakota/Beulah", label: "Central Time - North Dakota (Beulah)" },
    { value: "America/Boise", label: "Mountain Time - Idaho" }
  ]

  return (
    <>
    <Navbar />
    <Box sx={{ 
      minHeight: '100vh', 
      backgroundImage: `url(${MainImg})`,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
      position: 'relative',
      overflow: 'hidden',
      marginTop: { xs: '80px', sm: '80px', md: '80px' }
    }}>
      {/* Overlay for better text readability */}
      <Box sx={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        // backgroundColor: 'rgba(30, 58, 138, 0.3)',
        zIndex: 1
      }} />

      {/* Background Pattern */}
      <Box sx={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        opacity: 0.1,
        zIndex: 2,
        '&::before': {
          content: '""',
          position: 'absolute',
          top: '80px',
          left: '40px',
          width: '128px',
          height: '128px',
          border: '1px solid rgba(255,255,255,0.2)',
          borderRadius: '50%'
        },
        '&::after': {
          content: '""',
          position: 'absolute',
          top: '160px',
          right: '80px',
          width: '96px',
          height: '96px',
          border: '1px solid rgba(255,255,255,0.2)',
          borderRadius: '50%'
        }
      }} />

      <Box sx={{ 
        position: 'relative', 
        zIndex: 3 
      }}>
        {/* Main Content - Moved outside of cards */}
        <Box sx={{ 
          px: { xs: 2, sm: 3, md: 4 }, 
          pt: { xs: 4, sm: 6, md: 8 },
          textAlign: { xs: 'left', sm: 'left', md: 'left' },
          color: 'white',
          width: '80%',
          mx: 'auto'
        }}>
          <Typography variant="h3" sx={{ 
            color: 'white', 
            fontWeight: 'bold', 
            fontFamily: 'Rethink Sans Bold, sans-serif',
            mb: { xs: 1, sm: 2, md: 2 },
            fontSize: { xs: '1.5rem', sm: '1.75rem', md: '2rem', lg: '2.5rem' },
            lineHeight: 1.2,
            maxWidth: { xs: '100%', sm: '800px', md: '1100px' },
            textAlign: { xs: 'left', sm: 'left', md: 'left' }
          }}>
            Injured in a <span style={{ color: '#D14836' }}>Georgia </span> Car Accident?
            <Box component="span" sx={{ color: 'white', display: 'block', mt: { xs: 0.5, md: 1 } }}>
              You Focus On Healing, We'll Handle The Fight.
            </Box>
          </Typography>
          
          <Typography variant="body1" sx={{ 
            color: '#dbeafe', 
            mb: { xs: 2, sm: 3, md: 4 },
            maxWidth: { xs: '100%', sm: '600px', md: '700px' },
            fontSize: { xs: '0.9rem', sm: '1rem', md: '1.1rem' },
            lineHeight: 1.6,
            textAlign: { xs: 'left', sm: 'left', md: 'left' }
          }}>
            No Win. No Fee. We take on insurance companies so you don't have to.
          </Typography>

          <Box sx={{ 
            display: 'flex', 
            flexDirection: { xs: 'column', sm: 'row' }, 
            gap: { xs: 1, sm: 2 }, 
            mb: { xs: 2, sm: 3, md: 4 },
            alignItems: { xs: 'flex-start', sm: 'flex-start', md: 'flex-start' },
            justifyContent: { xs: 'flex-start', sm: 'flex-start', md: 'flex-start' }
          }}>
            <Button 
              variant="contained"
              onClick={() => setShowForm(true)}
              sx={{ 
                bgcolor: '#D14836',
                '&:hover': { bgcolor: '#b91c1c' },
                px: { xs: 2, sm: 3 },
                py: { xs: 1, sm: 1.5 },
                fontSize: { xs: '0.8rem', sm: '0.875rem' },
                fontWeight: 'bold',
                borderRadius: 2,
                width: { xs: '100%', sm: 'auto' },
                maxWidth: { xs: '280px', sm: 'none' }
              }}
            >
              Start Your Free Case Review
            </Button>
            
            <Button 
              variant="outlined"
              startIcon={<Phone />}
              onClick={handlePhoneCall}
              sx={{ 
                borderColor: 'white',
                color: 'white',
                '&:hover': { 
                  bgcolor: 'white',
                  color: '#1e3a8a'
                },
                px: { xs: 2, sm: 3 },
                py: { xs: 1, sm: 1.5 },
                fontSize: { xs: '0.8rem', sm: '0.875rem' },
                fontWeight: 'bold',
                borderRadius: 2,
                width: { xs: '100%', sm: 'auto' },
                maxWidth: { xs: '280px', sm: 'none' }
              }}
            >
              Call Now: (833) 352-0225
            </Button>
          </Box>
        </Box>

        {/* Section 2 - Map on the right */}
        <Box sx={{ 
          px: { xs: 2, sm: 3, md: 4 }, 
          textAlign: { xs: 'right', sm: 'right', md: 'right' },
          color: 'white',
          width: '100%',
          mt: { xs: 0, sm: 0, md: -16 },
          pb: { xs: 4, sm: 6, md: 0 }
        }}>
          <Box sx={{ 
            width: '100%', 
            height: { xs: '250px', sm: '300px', md: '450px' },
            borderRadius: 2,
            overflow: 'hidden',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            maxWidth: { xs: '100%', sm: '600px' },
            ml: 'auto'
          }}>
            <img 
              src={NImg} 
              alt="Nevada" 
              style={{
                width: '100%',
                height: '100%',
                objectFit: 'contain'
              }}
            />
          </Box>
        </Box>

        {/* Section 3 - Why Choose Our Services */}
        <Box sx={{ 
          px: { xs: 2, sm: 3, md: 4 }, 
          pb: { xs: 4, sm: 6, md: 8 },
          textAlign: { xs: 'left', sm: 'left', md: 'left' },
          color: 'white',
          width: '80%',
          mx: 'auto'
        }}>
          <Typography variant="h4" sx={{ 
            color: 'white', 
            mb: { xs: 1, sm: 2, md: 2 },
            fontSize: { xs: '1.5rem', sm: '1.75rem', md: '2rem', lg: '2.5rem' },
            fontWeight: 'bold',
            fontFamily: 'Rethink Sans Bold, sans-serif',
            textAlign: 'left'
          }}>
            Why you can Always <Box component="span" sx={{ color: '#D14836' }}>Trust Us </Box>
          </Typography>
          
          <Box sx={{ 
            display: 'flex', 
            gap: '5px',
            justifyContent: 'flex-start'
          }}>
            <Paper sx={{ 
              bgcolor: '#0A1F8F', 
              boxShadow: '0px 2px 4px rgba(0,0,0,0.1)',
              p: { xs: 1.5, sm: 2, md: 2.5 },
              textAlign: 'center',
              height: { xs: '100px', sm: '140px', md: '180px' },
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
              '&:hover': { bgcolor: '#0A1F8F' },
              transition: 'all 0.3s',
              border: '1px solid rgba(255,255,255,0.1)',
              width: '40%'
            }}>
              <Box sx={{ 
                fontSize: { xs: 24, sm: 28, md: 32 }, 
                mb: { xs: 0.5, sm: 1 },
                color: 'white',
                display: 'flex',
                alignItems: 'center',
                gap: 0.5
              }}>
                <img src={icon1} alt="icon1" style={{ 
                  width: { xs: '20px', sm: '24px', md: '28px' }, 
                  height: { xs: '20px', sm: '24px', md: '28px' } 
                }} />
              </Box>
              <Typography variant="body2" sx={{ 
                color: 'white', 
                fontSize: { xs: '0.7rem', sm: '0.8rem', md: '0.9rem' },
                fontWeight: 'medium',
                lineHeight: 1.2,
                textAlign: 'center'
              }}>
                Specialized<br />Legal Support
              </Typography>
            </Paper>
            
            <Paper sx={{ 
              bgcolor: '#0A1F8F', 
              boxShadow: '0px 2px 4px rgba(0,0,0,0.1)',
              p: { xs: 1.5, sm: 2, md: 2.5 },
              textAlign: 'center',
              height: { xs: '100px', sm: '140px', md: '180px' },
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
              '&:hover': { bgcolor: '#0A1F8F' },
              transition: 'all 0.3s',
              border: '1px solid rgba(255,255,255,0.1)',
              width: '40%'
            }}>
              <Box sx={{ 
                fontSize: { xs: 24, sm: 28, md: 32 }, 
                mb: { xs: 0.5, sm: 1 },
                color: 'white'
              }}>
                <img src={icon2} alt="icon2" style={{ 
                  width: { xs: '20px', sm: '24px', md: '28px' }, 
                  height: { xs: '20px', sm: '24px', md: '28px' } 
                }} />
              </Box>
              <Typography variant="body2" sx={{ 
                color: 'white', 
                fontSize: { xs: '0.7rem', sm: '0.8rem', md: '0.9rem' },
                fontWeight: 'medium',
                lineHeight: 1.2,
                textAlign: 'center'
              }}>
                No Upfront<br />Costs
              </Typography>
            </Paper>
            
            <Paper sx={{ 
              bgcolor: '#0A1F8F', 
              boxShadow: '0px 2px 4px rgba(0,0,0,0.1)',
              p: { xs: 1.5, sm: 2, md: 2.5 },
              textAlign: 'center',
              height: { xs: '100px', sm: '140px', md: '180px' },
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
              '&:hover': { bgcolor: '#0A1F8F' },
              transition: 'all 0.3s',
              border: '1px solid rgba(255,255,255,0.1)',
              width: '40%'
            }}>
              <Box sx={{ 
                fontSize: { xs: 24, sm: 28, md: 32 }, 
                mb: { xs: 0.5, sm: 1 },
                color: 'white'
              }}>
                <img src={icon3} alt="icon3" style={{ 
                  width: { xs: '20px', sm: '24px', md: '28px' }, 
                  height: { xs: '20px', sm: '24px', md: '28px' } 
                }} />
              </Box>
              <Typography variant="body2" sx={{ 
                color: 'white', 
                fontSize: { xs: '0.7rem', sm: '0.8rem', md: '0.9rem' },
                fontWeight: 'medium',
                lineHeight: 1.2,
                textAlign: 'center'
              }}>
                Confidential<br />Case Reviews
              </Typography>
            </Paper>
          </Box>
        </Box>
      </Box>

      {/* Form Dialog/Modal */}
      {showForm && (
        <Box sx={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          width: '100vw',
          height: '100vh',
          backgroundColor: 'rgba(0, 0, 0, 0.8)',
          zIndex: 1000,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          p: 0
        }}>
          <Box sx={{
            position: 'relative',
            width: '100vw',
            height: '100vh',
            bgcolor: 'white',
            overflow: 'hidden'
          }}>
            {/* Close Button */}
            <IconButton
              onClick={() => setShowForm(false)}
              sx={{
                position: 'absolute',
                top: 16,
                right: 16,
                zIndex: 1001,
                bgcolor: 'rgba(255,255,255,0.9)',
                '&:hover': { bgcolor: 'rgba(255,255,255,1)' }
              }}
            >
              <Close />
            </IconButton>

            {/* Form Content */}
            <Box sx={{
              display: 'flex',
              width: '100%',
              height: '100%'
            }}>
              {/* Left Side - Background Image */}
              <Box sx={{
                display: { xs: 'none', md: 'flex' },
                width: '50%',
                height: '100%',
                backgroundImage: currentStep === 1 ? `url(${Img1})` :
                              currentStep === 2 ? `url(${Img2})` :
                              currentStep === 3 ? `url(${Img3})` :
                              currentStep === 4 ? `url(${Img3})` :
                              currentStep === 5 ? `url(${Img3})` :
                              currentStep === 6 ? `url(${Img3})` : // Added step 6 background
                              `url(${Img3})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
                position: 'relative'
              }}>
                <Box sx={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  backgroundColor: 'rgba(0,0,0,0.3)',
                  zIndex: 1
                }} />
              </Box>

              {/* Right Side - Form */}
              <Box sx={{
                width: { xs: '100%', md: '50%' },
                height: '100%',
                p: { xs: 2, sm: 3, md: 4 },
                overflowY: 'auto',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center'
              }}>
                <Card sx={{ 
                  width: '100%', 
                  bgcolor: 'transparent',
                  boxShadow: 'none',
                  border: 'none'
                }}>
                  <CardContent sx={{ 
                    p: 0, 
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center'
                  }}>
                    {/* Step 1: Accident Type & Injury Level */}
                    {currentStep === 1 && (
                      <Box sx={{ space: 2 }}>
                        <Typography variant="h5" sx={{ 
                          fontWeight: 'bold', 
                          color: 'text.primary', 
                          mb: { xs: 2, sm: 3 },
                          textAlign: 'center',
                          fontSize: { xs: '0.9rem', sm: '1rem' }
                        }}>
                          A <Box component="span" sx={{ color: '#E05C4B' }}>Few Seconds</Box> Is All It Takes To See If You Have A Valid Case
                        </Typography>
                        
                        {/* Accident Type Section */}
                        <Box sx={{ mb: { xs: 3, sm: 4 } }}>
                          <Typography variant="h6" sx={{ 
                            fontWeight: 'bold', 
                            color: 'text.primary', 
                            mb: { xs: 1.5, sm: 2 },
                            textAlign: 'center',
                            fontSize: { xs: '0.8rem', sm: '0.875rem' }
                          }}>
                            What Type Of Accident?
                          </Typography>
                          <Grid container spacing={{ xs: 1, sm: 2 }}>
                            <Grid item xs={6}>
                              <Card 
                                onClick={() => handleInputChange("accidentType", "car")}
                                sx={{ 
                                  cursor: 'pointer',
                                  border: formData.accidentType === "car" ? '2px solid #0A1F8F' : '1px solid #e5e7eb',
                                  bgcolor: formData.accidentType === "car" ? '#0A1F8F' : '#f9fafb',
                                  transition: 'all 0.3s ease',
                                  height: { xs: '120px', sm: '140px' },
                                  '&:hover': {
                                    borderColor: '#0A1F8F',
                                    bgcolor: formData.accidentType === "car" ? '#0A1F8F' : '#f3f4f6'
                                  }
                                }}
                              >
                                <CardContent sx={{ 
                                  textAlign: 'center', 
                                  py: { xs: 2, sm: 3 },
                                  color: formData.accidentType === "car" ? 'white' : '#6b7280',
                                  height: '100%',
                                  display: 'flex',
                                  flexDirection: 'column',
                                  justifyContent: 'center'
                                }}>
                                  <img 
                                    src={carIcon} 
                                    alt="Car Accident" 
                                    style={{ 
                                      width: '60%', 
                                      height: 'auto',
                                      marginBottom: '8px',
                                      display: 'block',
                                      marginLeft: 'auto',
                                      marginRight: 'auto'
                                    }}
                                    className={`${
                                      formData.accidentType === "car" ? 'filter brightness-0 invert' : ''
                                    }`}
                                  />
                                  <Typography variant="body1" sx={{ 
                                    fontWeight: 'medium', 
                                    fontSize: { xs: '0.75rem', sm: '0.875rem' } 
                                  }}>
                                    Car
                                  </Typography>
                                </CardContent>
                              </Card>
                            </Grid>
                            <Grid item xs={6}>
                              <Card 
                                onClick={() => handleInputChange("accidentType", "truck")}
                                sx={{ 
                                  cursor: 'pointer',
                                  border: formData.accidentType === "truck" ? '2px solid #0A1F8F' : '1px solid #e5e7eb',
                                  bgcolor: formData.accidentType === "truck" ? '#0A1F8F' : '#f9fafb',
                                  transition: 'all 0.3s ease',
                                  height: { xs: '120px', sm: '140px' },
                                  '&:hover': {
                                    borderColor: '#0A1F8F',
                                    bgcolor: formData.accidentType === "truck" ? '#0A1F8F' : '#f3f4f6'
                                  }
                                }}
                              >
                                <CardContent sx={{ 
                                  textAlign: 'center', 
                                  py: { xs: 2, sm: 3 },
                                  color: formData.accidentType === "truck" ? 'white' : '#6b7280',
                                  height: '100%',
                                  display: 'flex',
                                  flexDirection: 'column',
                                  justifyContent: 'center'
                                }}>
                                  <img 
                                    src={truckIcon} 
                                    alt="Truck Accident" 
                                    style={{ 
                                      width: '60%', 
                                      height: 'auto',
                                      marginBottom: '8px',
                                      display: 'block',
                                      marginLeft: 'auto',
                                      marginRight: 'auto'
                                    }}
                                    className={`${
                                      formData.accidentType === "truck" ? 'filter brightness-0 invert' : ''
                                    }`}
                                  />
                                  <Typography variant="body1" sx={{ 
                                    fontWeight: 'medium', 
                                    fontSize: { xs: '0.75rem', sm: '0.875rem' } 
                                  }}>
                                    Pickup Truck
                                  </Typography>
                                </CardContent>
                              </Card>
                            </Grid>
                          </Grid>
                        </Box>

                        {/* Injury Level Section */}
                        <Box sx={{ mb: { xs: 3, sm: 4 } }}>
                          <Typography variant="h6" sx={{ 
                            fontWeight: 'bold', 
                            color: 'text.primary', 
                            mb: { xs: 1.5, sm: 2 },
                            textAlign: 'center',
                            fontSize: { xs: '0.8rem', sm: '0.875rem' }
                          }}>
                            What Was The Level Of Injury?
                          </Typography>
                          <Grid container spacing={{ xs: 1, sm: 2 }} justifyContent="center">
                            <Grid item xs={4}>
                              <Box 
                                onClick={() => handleInputChange("injuryLevel", "mild")}
                                sx={{ 
                                  cursor: 'pointer',
                                  textAlign: 'center',
                                  transition: 'all 0.3s ease'
                                }}
                              >
                                <Box sx={{
                                  width: { xs: 60, sm: 80 },
                                  height: { xs: 60, sm: 80 },
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  mx: 'auto',
                                  mb: 1,
                                  '&:hover': {
                                    transform: 'scale(1.05)'
                                  }
                                }}>
                                  <img 
                                    src={formData.injuryLevel === "mild" ? MildActive : MildDef} 
                                    alt="Mild Injury"
                                    style={{ 
                                      width: { xs: '60px', sm: '80px' }, 
                                      height: { xs: '60px', sm: '80px' } 
                                    }}
                                  />
                                </Box>
                                <Typography variant="body2" sx={{ 
                                  color: formData.injuryLevel === "mild" ? '#0A1F8F' : '#6b7280',
                                  fontWeight: 'medium',
                                  fontSize: { xs: '0.65rem', sm: '0.75rem' }
                                }}>
                                  Mild Injury
                                </Typography>
                              </Box>
                            </Grid>
                            <Grid item xs={4}>
                              <Box 
                                onClick={() => handleInputChange("injuryLevel", "serious")}
                                sx={{ 
                                  cursor: 'pointer',
                                  textAlign: 'center',
                                  transition: 'all 0.3s ease'
                                }}
                              >
                                <Box sx={{
                                  width: { xs: 60, sm: 80 },
                                  height: { xs: 60, sm: 80 },
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  mx: 'auto',
                                  mb: 1,
                                  '&:hover': {
                                    transform: 'scale(1.05)'
                                  }
                                }}>
                                  <img 
                                    src={formData.injuryLevel === "serious" ? MildSerious : SeriousDef} 
                                    alt="Serious Injury"
                                    style={{ 
                                      width: { xs: '60px', sm: '80px' }, 
                                      height: { xs: '60px', sm: '80px' } 
                                    }}
                                  />
                                </Box>
                                <Typography variant="body2" sx={{ 
                                  color: formData.injuryLevel === "serious" ? '#0A1F8F' : '#6b7280',
                                  fontWeight: 'medium',
                                  fontSize: { xs: '0.65rem', sm: '0.75rem' }
                                }}>
                                  Serious Injury
                                </Typography>
                              </Box>
                            </Grid>
                            <Grid item xs={4}>
                              <Box 
                                onClick={() => handleInputChange("injuryLevel", "death")}
                                sx={{ 
                                  cursor: 'pointer',
                                  textAlign: 'center',
                                  transition: 'all 0.3s ease'
                                }}
                              >
                                <Box sx={{
                                  width: { xs: 60, sm: 80 },
                                  height: { xs: 60, sm: 80 },
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  mx: 'auto',
                                  mb: 1,
                                  '&:hover': {
                                    transform: 'scale(1.05)'
                                  }
                                }}>
                                  <img 
                                    src={formData.injuryLevel === "death" ? deadAct : deadinact} 
                                    alt="Death"
                                    style={{ 
                                      width: { xs: '60px', sm: '80px' }, 
                                      height: { xs: '60px', sm: '80px' } 
                                    }}
                                  />
                                </Box>
                                <Typography variant="body2" sx={{ 
                                  color: formData.injuryLevel === "death" ? '#0A1F8F' : '#6b7280',
                                  fontWeight: 'medium',
                                  fontSize: { xs: '0.65rem', sm: '0.75rem' }
                                }}>
                                  Death
                                </Typography>
                              </Box>
                            </Grid>
                          </Grid>
                        </Box>
                      </Box>
                    )}

                    {/* Step 2: Who Was In The Accident & Who Was At Fault */}
                    {currentStep === 2 && (
                      <Box sx={{ space: 2 }}>
                        <Typography variant="h5" sx={{ 
                          fontWeight: 'bold', 
                          color: 'text.primary', 
                          mb: { xs: 2, sm: 3 },
                          textAlign: 'center',
                          fontSize: { xs: '0.9rem', sm: '1rem' }
                        }}>
                          A <Box component="span" sx={{ color: '#E05C4B' }}>Few Seconds</Box> Is All It Takes To See If You Have A Valid Case
                        </Typography>
                        
                        {/* Who Was In The Accident Section */}
                        <Box sx={{ mb: { xs: 3, sm: 4 } }}>
                          <Typography variant="h6" sx={{ 
                            fontWeight: 'bold', 
                            color: 'text.primary', 
                            mb: { xs: 1.5, sm: 2 },
                            textAlign: 'center',
                            fontSize: { xs: '0.8rem', sm: '0.875rem' }
                          }}>
                            Who Was In The Accident?
                          </Typography>
                          <Grid container spacing={{ xs: 1, sm: 2 }}>
                            <Grid item xs={4}>
                              <Card 
                                onClick={() => handleInputChange("whoWasInAccident", "me")}
                                sx={{ 
                                  cursor: 'pointer',
                                  border: formData.whoWasInAccident === "me" ? '2px solid #0A1F8F' : '1px solid #e5e7eb',
                                  bgcolor: formData.whoWasInAccident === "me" ? '#0A1F8F' : '#f9fafb',
                                  transition: 'all 0.3s ease',
                                  '&:hover': {
                                    borderColor: '#0A1F8F',
                                    bgcolor: formData.whoWasInAccident === "me" ? '#0A1F8F' : '#f3f4f6'
                                  }
                                }}
                              >
                                <CardContent sx={{ 
                                  textAlign: 'center', 
                                  py: { xs: 2, sm: 3 },
                                  color: formData.whoWasInAccident === "me" ? 'white' : '#6b7280'
                                }}>
                                  <Box sx={{ position: 'relative', display: 'inline-block' }}>
                                    <Person sx={{ 
                                      fontSize: 48, 
                                      mb: 1,
                                      color: formData.whoWasInAccident === "me" ? 'white' : '#9ca3af'
                                    }} />
                                    <Box sx={{
                                      position: 'absolute',
                                      top: -5,
                                      right: -5,
                                      width: 20,
                                      height: 20,
                                      borderRadius: '50%',
                                      bgcolor: formData.whoWasInAccident === "me" ? 'white' : 'transparent',
                                      display: 'flex',
                                      alignItems: 'center',
                                      justifyContent: 'center',
                                      border: formData.whoWasInAccident === "me" ? '1px solid #0A1F8F' : 'none'
                                    }}>
                                      <Typography variant="body2" sx={{ 
                                        color: formData.whoWasInAccident === "me" ? '#0A1F8F' : 'transparent',
                                        fontSize: '0.75rem',
                                        fontWeight: 'bold'
                                      }}>
                                        ✓
                                      </Typography>
                                    </Box>
                                  </Box>
                                  <Typography variant="body1" sx={{ 
                                    fontWeight: 'medium', 
                                    fontSize: { xs: '0.75rem', sm: '0.875rem' } 
                                  }}>
                                    I was in the accident
                                  </Typography>
                                </CardContent>
                              </Card>
                            </Grid>
                            <Grid item xs={4}>
                              <Card 
                                onClick={() => handleInputChange("whoWasInAccident", "passenger")}
                                sx={{ 
                                  cursor: 'pointer',
                                  border: formData.whoWasInAccident === "passenger" ? '2px solid #0A1F8F' : '1px solid #e5e7eb',
                                  bgcolor: formData.whoWasInAccident === "passenger" ? '#0A1F8F' : '#f9fafb',
                                  transition: 'all 0.3s ease',
                                  '&:hover': {
                                    borderColor: '#0A1F8F',
                                    bgcolor: formData.whoWasInAccident === "passenger" ? '#0A1F8F' : '#f3f4f6'
                                  }
                                }}
                              >
                                <CardContent sx={{ 
                                  textAlign: 'center', 
                                  py: { xs: 2, sm: 3 },
                                  color: formData.whoWasInAccident === "passenger" ? 'white' : '#6b7280'
                                }}>
                                  <Person sx={{ 
                                    fontSize: 48, 
                                    mb: 1,
                                    color: formData.whoWasInAccident === "passenger" ? 'white' : '#9ca3af'
                                  }} />
                                  <Typography variant="body1" sx={{ 
                                    fontWeight: 'medium', 
                                    fontSize: { xs: '0.75rem', sm: '0.875rem' } 
                                  }}>
                                    I was the passenger
                                  </Typography>
                                </CardContent>
                              </Card>
                            </Grid>
                            <Grid item xs={4}>
                              <Card 
                                onClick={() => handleInputChange("whoWasInAccident", "caretaker")}
                                sx={{ 
                                  cursor: 'pointer',
                                  border: formData.whoWasInAccident === "caretaker" ? '2px solid #0A1F8F' : '1px solid #e5e7eb',
                                  bgcolor: formData.whoWasInAccident === "caretaker" ? '#0A1F8F' : '#f9fafb',
                                  transition: 'all 0.3s ease',
                                  '&:hover': {
                                    borderColor: '#0A1F8F',
                                    bgcolor: formData.whoWasInAccident === "caretaker" ? '#0A1F8F' : '#f3f4f6'
                                  }
                                }}
                              >
                                <CardContent sx={{ 
                                  textAlign: 'center', 
                                  py: { xs: 2, sm: 3 },
                                  color: formData.whoWasInAccident === "caretaker" ? 'white' : '#6b7280'
                                }}>
                                  <Group sx={{ 
                                    fontSize: 48, 
                                    mb: 1,
                                    color: formData.whoWasInAccident === "caretaker" ? 'white' : '#9ca3af'
                                  }} />
                                  <Typography variant="body1" sx={{ 
                                    fontWeight: 'medium', 
                                    fontSize: { xs: '0.75rem', sm: '0.875rem' } 
                                  }}>
                                    I am the Caretaker
                                  </Typography>
                                </CardContent>
                              </Card>
                            </Grid>
                          </Grid>
                        </Box>

                        {/* Who Was At Fault Section */}
                        <Box sx={{ mb: { xs: 3, sm: 4 } }}>
                          <Typography variant="h6" sx={{ 
                            fontWeight: 'bold', 
                            color: 'text.primary', 
                            mb: { xs: 1.5, sm: 2 },
                            textAlign: 'center',
                            fontSize: { xs: '0.8rem', sm: '0.875rem' }
                          }}>
                            Who Was At Fault?
                          </Typography>
                          <Grid container spacing={{ xs: 1, sm: 2 }} justifyContent="center">
                            <Grid item xs={4}>
                              <Box 
                                onClick={() => handleInputChange("whoWasAtFault", "injured")}
                                sx={{ 
                                  cursor: 'pointer',
                                  textAlign: 'center',
                                  transition: 'all 0.3s ease'
                                }}
                              >
                                <Box sx={{
                                  width: { xs: 60, sm: 80 },
                                  height: { xs: 60, sm: 80 },
                                  borderRadius: '50%',
                                  bgcolor: formData.whoWasAtFault === "injured" ? '#0A1F8F' : '#e5e7eb',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  mx: 'auto',
                                  mb: 1,
                                  border: formData.whoWasAtFault === "injured" ? '2px solid #0A1F8F' : '1px solid #d1d5db',
                                  '&:hover': {
                                    bgcolor: formData.whoWasAtFault === "injured" ? '#0A1F8F' : '#f3f4f6'
                                  }
                                }}>
                                  <Typography variant="h4" sx={{ 
                                    color: formData.whoWasAtFault === "injured" ? 'white' : '#9ca3af'
                                  }}>
                                    🤕
                                  </Typography>
                                </Box>
                                <Typography variant="body2" sx={{ 
                                  color: formData.whoWasAtFault === "injured" ? '#0A1F8F' : '#6b7280',
                                  fontWeight: 'medium',
                                  fontSize: { xs: '0.65rem', sm: '0.75rem' }
                                }}>
                                  Injured Person
                                </Typography>
                              </Box>
                            </Grid>
                            <Grid item xs={4}>
                              <Box 
                                onClick={() => handleInputChange("whoWasAtFault", "someone-else")}
                                sx={{ 
                                  cursor: 'pointer',
                                  textAlign: 'center',
                                  transition: 'all 0.3s ease'
                                }}
                              >
                                <Box sx={{
                                  width: { xs: 60, sm: 80 },
                                  height: { xs: 60, sm: 80 },
                                  borderRadius: '50%',
                                  bgcolor: formData.whoWasAtFault === "someone-else" ? '#0A1F8F' : '#e5e7eb',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  mx: 'auto',
                                  mb: 1,
                                  border: formData.whoWasAtFault === "someone-else" ? '2px solid #0A1F8F' : '1px solid #d1d5db',
                                  '&:hover': {
                                    bgcolor: formData.whoWasAtFault === "someone-else" ? '#0A1F8F' : '#f3f4f6'
                                  }
                                }}>
                                  <Typography variant="h4" sx={{ 
                                    color: formData.whoWasAtFault === "someone-else" ? 'white' : '#9ca3af'
                                  }}>
                                    😱
                                  </Typography>
                                </Box>
                                <Typography variant="body2" sx={{ 
                                  color: formData.whoWasAtFault === "someone-else" ? '#0A1F8F' : '#6b7280',
                                  fontWeight: 'medium',
                                  fontSize: { xs: '0.65rem', sm: '0.75rem' }
                                }}>
                                  Someone else
                                </Typography>
                              </Box>
                            </Grid>
                            <Grid item xs={4}>
                              <Box 
                                onClick={() => handleInputChange("whoWasAtFault", "dont-know")}
                                sx={{ 
                                  cursor: 'pointer',
                                  textAlign: 'center',
                                  transition: 'all 0.3s ease'
                                }}
                              >
                                <Box sx={{
                                  width: { xs: 60, sm: 80 },
                                  height: { xs: 60, sm: 80 },
                                  borderRadius: '50%',
                                  bgcolor: formData.whoWasAtFault === "dont-know" ? '#0A1F8F' : '#e5e7eb',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  mx: 'auto',
                                  mb: 1,
                                  border: formData.whoWasAtFault === "dont-know" ? '2px solid #0A1F8F' : '1px solid #d1d5db',
                                  '&:hover': {
                                    bgcolor: formData.whoWasAtFault === "dont-know" ? '#0A1F8F' : '#f3f4f6'
                                  }
                                }}>
                                  <Typography variant="h4" sx={{ 
                                    color: formData.whoWasAtFault === "dont-know" ? 'white' : '#9ca3af'
                                  }}>
                                    😵
                                  </Typography>
                                </Box>
                                <Typography variant="body2" sx={{ 
                                  color: formData.whoWasAtFault === "dont-know" ? '#0A1F8F' : '#6b7280',
                                  fontWeight: 'medium',
                                  fontSize: { xs: '0.65rem', sm: '0.75rem' }
                                }}>
                                  I don't Know
                                </Typography>
                              </Box>
                            </Grid>
                          </Grid>
                        </Box>
                      </Box>
                    )}

                    {/* Step 3: Insurance Information */}
                    {currentStep === 3 && (
                      <Box sx={{ space: 2 }}>
                        <Typography variant="h5" sx={{ 
                          fontWeight: 'bold', 
                          color: 'text.primary', 
                          mb: { xs: 2, sm: 3 },
                          textAlign: 'center',
                          fontSize: { xs: '0.9rem', sm: '1rem' }
                        }}>
                          A <Box component="span" sx={{ color: '#E05C4B' }}>Few Seconds</Box> Is All It Takes To See If You Have A Valid Case
                        </Typography>
                        
                        {/* Insurance Question Section */}
                        <Box sx={{ mb: { xs: 3, sm: 4 } }}>
                          <Grid container spacing={{ xs: 1, sm: 2 }} justifyContent="center">
                            <Grid item xs={4}>
                              <Box 
                                onClick={() => handleInputChange("wereYouInsured", "yes")}
                                sx={{ 
                                  cursor: 'pointer',
                                  textAlign: 'center',
                                  transition: 'all 0.3s ease'
                                }}
                              >
                                <Box sx={{
                                  width: { xs: 60, sm: 80 },
                                  height: { xs: 60, sm: 80 },
                                  borderRadius: '50%',
                                  bgcolor: formData.wereYouInsured === "yes" ? '#0A1F8F' : '#e5e7eb',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  mx: 'auto',
                                  mb: 1,
                                  border: formData.wereYouInsured === "yes" ? '2px solid #0A1F8F' : '1px solid #d1d5db',
                                  '&:hover': {
                                    bgcolor: formData.wereYouInsured === "yes" ? '#0A1F8F' : '#f3f4f6'
                                  }
                                }}>
                                  <Typography variant="h4" sx={{ 
                                    color: formData.wereYouInsured === "yes" ? 'white' : '#9ca3af',
                                    fontWeight: 'bold'
                                  }}>
                                    ✓
                                  </Typography>
                                </Box>
                                <Typography variant="body2" sx={{ 
                                  color: formData.wereYouInsured === "yes" ? '#0A1F8F' : '#6b7280',
                                  fontWeight: 'medium',
                                  fontSize: { xs: '0.65rem', sm: '0.75rem' }
                                }}>
                                  Yes
                                </Typography>
                              </Box>
                            </Grid>
                            <Grid item xs={4}>
                              <Box 
                                onClick={() => handleInputChange("wereYouInsured", "no")}
                                sx={{ 
                                  cursor: 'pointer',
                                  textAlign: 'center',
                                  transition: 'all 0.3s ease'
                                }}
                              >
                                <Box sx={{
                                  width: { xs: 60, sm: 80 },
                                  height: { xs: 60, sm: 80 },
                                  borderRadius: '50%',
                                  bgcolor: formData.wereYouInsured === "no" ? '#0A1F8F' : '#e5e7eb',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  mx: 'auto',
                                  mb: 1,
                                  border: formData.wereYouInsured === "no" ? '2px solid #0A1F8F' : '1px solid #d1d5db',
                                  '&:hover': {
                                    bgcolor: formData.wereYouInsured === "no" ? '#0A1F8F' : '#f3f4f6'
                                  }
                                }}>
                                  <Typography variant="h4" sx={{ 
                                    color: formData.wereYouInsured === "no" ? 'white' : '#9ca3af',
                                    fontWeight: 'bold'
                                  }}>
                                    ✕
                                  </Typography>
                                </Box>
                                <Typography variant="body2" sx={{ 
                                  color: formData.wereYouInsured === "no" ? '#0A1F8F' : '#6b7280',
                                  fontWeight: 'medium',
                                  fontSize: { xs: '0.65rem', sm: '0.75rem' }
                                }}>
                                  No
                                </Typography>
                              </Box>
                            </Grid>
                            <Grid item xs={4}>
                              <Box 
                                onClick={() => handleInputChange("wereYouInsured", "dont-know")}
                                sx={{ 
                                  cursor: 'pointer',
                                  textAlign: 'center',
                                  transition: 'all 0.3s ease'
                                }}
                              >
                                <Box sx={{
                                  width: { xs: 60, sm: 80 },
                                  height: { xs: 60, sm: 80 },
                                  borderRadius: '50%',
                                  bgcolor: formData.wereYouInsured === "dont-know" ? '#0A1F8F' : '#e5e7eb',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  mx: 'auto',
                                  mb: 1,
                                  border: formData.wereYouInsured === "dont-know" ? '2px solid #0A1F8F' : '1px solid #d1d5db',
                                  '&:hover': {
                                    bgcolor: formData.wereYouInsured === "dont-know" ? '#0A1F8F' : '#f3f4f6'
                                  }
                                }}>
                                  <Typography variant="h4" sx={{ 
                                    color: formData.wereYouInsured === "dont-know" ? 'white' : '#9ca3af',
                                    fontWeight: 'bold'
                                  }}>
                                    ?
                                  </Typography>
                                </Box>
                                <Typography variant="body2" sx={{ 
                                  color: formData.wereYouInsured === "dont-know" ? '#0A1F8F' : '#6b7280',
                                  fontWeight: 'medium',
                                  fontSize: { xs: '0.65rem', sm: '0.75rem' }
                                }}>
                                  I don't Know
                                </Typography>
                              </Box>
                            </Grid>
                          </Grid>
                        </Box>
                      </Box>
                    )}

                    {/* Step 4: Contact Information */}
                    {currentStep === 4 && (
                      <Box sx={{ space: 2 }}>
                        <Typography variant="h4" sx={{ 
                          fontWeight: 'bold', 
                          color: 'text.primary', 
                          mb: { xs: 2, sm: 3 },
                          textAlign: 'center',
                          fontSize: { xs: '1.1rem', sm: '1.25rem' }
                        }}>
                          Let's Get In Touch
                        </Typography>
                        
                        <TextField
                          fullWidth
                          label="Full Name"
                          size="small"
                          value={formData.fullName}
                          onChange={(e) => handleInputChange("fullName", e.target.value)}
                          sx={{ mb: 2 }}
                        />
                        
                        <TextField
                          fullWidth
                          label="Phone Number"
                          size="small"
                          value={formData.phoneNumber}
                          onChange={handlePhoneNumberChange}
                          sx={{ mb: 2 }}
                        />
                        
                        <TextField
                          fullWidth
                          label="Email"
                          type="email"
                          size="small"
                          value={formData.email}
                          onChange={(e) => handleInputChange("email", e.target.value)}
                          sx={{ mb: 3 }}
                        />

                        {/* Consent Section */}
                        <Box sx={{ mb: 3 }}>
                          <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1 }}>
                            <Checkbox
                              checked={formData.consent}
                              onChange={(e) => handleInputChange("consent", e.target.checked)}
                              sx={{ mt: 0.5 }}
                            />
                            <Typography variant="body2" sx={{ 
                              color: 'text.secondary', 
                              fontSize: { xs: '0.75rem', sm: '0.875rem' }, 
                              lineHeight: 1.4 
                            }}>
                              I agree to the{' '}
                              <Link 
                                component="button"
                                onClick={() => navigate('/PrivacyPolicy')}
                                sx={{ color: '#E05C4B', textDecoration: 'none', fontWeight: 'medium', border: 'none', background: 'none', cursor: 'pointer', p: 0, font: 'inherit' }}
                              >
                                Privacy policy
                              </Link>
                              {' '}and{' '}
                              <Link 
                                component="button"
                                onClick={() => navigate('/Disclaimer')}
                                sx={{ color: '#E05C4B', textDecoration: 'none', fontWeight: 'medium', border: 'none', background: 'none', cursor: 'pointer', p: 0, font: 'inherit' }}
                              >
                                Disclaimer
                              </Link>
                              {' '}and give my express written consent, affiliates and/or lawyer to contact you at the number provided above, even if this number is a wireless number or if I am presently listed on a Do Not Call list. I understand that I may be contacted by telephone, email, text message or mail regarding case options and that I may be called using automatic dialing equipment. Message and data rates may apply. My consent does not require purchase. This is Legal advertising.
                            </Typography>
                          </Box>
                        </Box>
                      </Box>
                    )}

                    {/* Step 5: Contact Preference */}
                    {currentStep === 5 && (
                      <Box sx={{ space: 2 }}>
                        {/* Contact Preference Options */}
                        <Grid container spacing={{ xs: 1, sm: 2 }}>
                          <Grid item xs={6}>
                            <Box 
                              onClick={() => handleInputChange("contactPreference", "call-now")}
                              sx={{ 
                                cursor: 'pointer',
                                textAlign: 'center',
                                transition: 'all 0.3s ease'
                              }}
                            >
                              <Box sx={{
                                width: { xs: 60, sm: 80 },
                                height: { xs: 60, sm: 80 },
                                borderRadius: '50%',
                                bgcolor: formData.contactPreference === "call-now" ? '#0A1F8F' : '#e5e7eb',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                mx: 'auto',
                                mb: 1,
                                border: formData.contactPreference === "call-now" ? '2px solid #0A1F8F' : '1px solid #d1d5db',
                                '&:hover': {
                                  bgcolor: formData.contactPreference === "call-now" ? '#0A1F8F' : '#f3f4f6'
                                }
                              }}>
                                <Phone sx={{ 
                                  fontSize: { xs: 24, sm: 32 }, 
                                  color: formData.contactPreference === "call-now" ? 'white' : '#0A1F8F'
                                }} />
                              </Box>
                              <Typography variant="body2" sx={{ 
                                color: formData.contactPreference === "call-now" ? '#0A1F8F' : '#0A1F8F',
                                fontWeight: 'medium',
                                fontSize: { xs: '0.65rem', sm: '0.75rem' }
                              }}>
                                Call Me Now
                              </Typography>
                            </Box>
                          </Grid>
                          <Grid item xs={6}>
                            <Box 
                              onClick={() => handleInputChange("contactPreference", "schedule-call")}
                              sx={{ 
                                cursor: 'pointer',
                                textAlign: 'center',
                                transition: 'all 0.3s ease'
                              }}
                            >
                              <Box sx={{
                                width: { xs: 60, sm: 80 },
                                height: { xs: 60, sm: 80 },
                                borderRadius: '50%',
                                bgcolor: formData.contactPreference === "schedule-call" ? '#0A1F8F' : '#e5e7eb',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                mx: 'auto',
                                mb: 1,
                                border: formData.contactPreference === "schedule-call" ? '2px solid #0A1F8F' : '1px solid #d1d5db',
                                '&:hover': {
                                  bgcolor: formData.contactPreference === "schedule-call" ? '#0A1F8F' : '#f3f4f6'
                                }
                              }}>
                                <Box sx={{ 
                                  fontSize: { xs: 24, sm: 32 }, 
                                  color: formData.contactPreference === "schedule-call" ? 'white' : '#0A1F8F',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center'
                                }}>
                                  📅
                                </Box>
                              </Box>
                              <Typography variant="body2" sx={{ 
                                color: formData.contactPreference === "schedule-call" ? '#0A1F8F' : '#6b7280',
                                fontWeight: 'medium',
                                fontSize: { xs: '0.65rem', sm: '0.75rem' }
                              }}>
                                Schedule a Call
                              </Typography>
                            </Box>
                          </Grid>
                          <Grid item xs={6}>
                            <Box 
                              onClick={() => handleInputChange("contactPreference", "text-me")}
                              sx={{ 
                                cursor: 'pointer',
                                textAlign: 'center',
                                transition: 'all 0.3s ease'
                              }}
                            >
                              <Box sx={{
                                width: { xs: 60, sm: 80 },
                                height: { xs: 60, sm: 80 },
                                borderRadius: '50%',
                                bgcolor: formData.contactPreference === "text-me" ? '#0A1F8F' : '#e5e7eb',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                mx: 'auto',
                                mb: 1,
                                border: formData.contactPreference === "text-me" ? '2px solid #0A1F8F' : '1px solid #d1d5db',
                                '&:hover': {
                                  bgcolor: formData.contactPreference === "text-me" ? '#0A1F8F' : '#f3f4f6'
                                }
                              }}>
                                <Box sx={{ 
                                  fontSize: { xs: 24, sm: 32 }, 
                                  color: formData.contactPreference === "text-me" ? 'white' : '#0A1F8F',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center'
                                }}>
                                  💬
                                </Box>
                              </Box>
                              <Typography variant="body2" sx={{ 
                                color: formData.contactPreference === "text-me" ? '#0A1F8F' : '#6b7280',
                                fontWeight: 'medium',
                                fontSize: { xs: '0.65rem', sm: '0.75rem' }
                              }}>
                                Text Me
                              </Typography>
                            </Box>
                          </Grid>
                          <Grid item xs={6}>
                            <Box 
                              onClick={() => handleInputChange("contactPreference", "email-me")}
                              sx={{ 
                                cursor: 'pointer',
                                textAlign: 'center',
                                transition: 'all 0.3s ease'
                              }}
                            >
                              <Box sx={{
                                width: { xs: 60, sm: 80 },
                                height: { xs: 60, sm: 80 },
                                borderRadius: '50%',
                                bgcolor: formData.contactPreference === "email-me" ? '#0A1F8F' : '#e5e7eb',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                mx: 'auto',
                                mb: 1,
                                border: formData.contactPreference === "email-me" ? '2px solid #0A1F8F' : '1px solid #d1d5db',
                                '&:hover': {
                                  bgcolor: formData.contactPreference === "email-me" ? '#0A1F8F' : '#f3f4f6'
                                }
                              }}>
                                <Box sx={{ 
                                  fontSize: { xs: 24, sm: 32 }, 
                                  color: formData.contactPreference === "email-me" ? 'white' : '#0A1F8F',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center'
                                }}>
                                  ✉️
                                </Box>
                              </Box>
                              <Typography variant="body2" sx={{ 
                                color: formData.contactPreference === "email-me" ? '#0A1F8F' : '#6b7280',
                                fontWeight: 'medium',
                                fontSize: { xs: '0.65rem', sm: '0.75rem' }
                              }}>
                                Email Me
                              </Typography>
                            </Box>
                          </Grid>
                        </Grid>
                      </Box>
                    )}

                    {/* Step 6: Final Step based on contact preference */}
                    {currentStep === 6 && (
                      <Box sx={{ space: 2 }}>
                        {formData.contactPreference === "schedule-call" ? (
                          // Schedule a Call - Date and Time Picker
                          <Box sx={{ space: 2 }}>
                            <Typography variant="h4" sx={{ 
                              fontWeight: 'bold', 
                              color: 'text.primary', 
                              mb: { xs: 2, sm: 3 },
                              textAlign: 'center',
                              fontSize: { xs: '1.1rem', sm: '1.25rem' }
                            }}>
                              Schedule Your Call
                            </Typography>
                            
                            <TextField
                              fullWidth
                              label="Preferred Date"
                              type="date"
                              size="small"
                              value={formData.scheduledDate}
                              onChange={(e) => handleInputChange("scheduledDate", e.target.value)}
                              InputLabelProps={{ shrink: true }}
                              sx={{ mb: 2 }}
                            />
                            
                            <TextField
                              fullWidth
                              label="Preferred Time"
                              type="time"
                              size="small"
                              value={formData.scheduledTime}
                              onChange={(e) => handleInputChange("scheduledTime", e.target.value)}
                              InputLabelProps={{ shrink: true }}
                              sx={{ mb: 2 }}
                            />

                            <FormControl fullWidth size="small" sx={{ mb: 3 }}>
                              <InputLabel>Timezone</InputLabel>
                              <Select
                                value={formData.timezone}
                                onChange={(e) => handleInputChange("timezone", e.target.value)}
                                label="Timezone"
                              >
                                {usTimezones.map((tz) => (
                                  <MenuItem key={tz.value} value={tz.value}>
                                    {tz.label}
                                  </MenuItem>
                                ))}
                              </Select>
                            </FormControl>

                            <Typography variant="body2" sx={{ 
                              color: 'text.secondary', 
                              fontSize: { xs: '0.75rem', sm: '0.875rem' }, 
                              lineHeight: 1.4,
                              mb: 3,
                              textAlign: 'center'
                            }}>
                              We'll call you at your preferred time. If you need to reschedule, please contact us at (833) 309-7030.
                            </Typography>
                          </Box>
                        ) : (
                          // Text Me or Email Me - Confirmation Message
                          <Box sx={{ space: 2, textAlign: 'center' }}>
                            <Typography variant="h4" sx={{ 
                              fontWeight: 'bold', 
                              color: 'text.primary', 
                              mb: { xs: 2, sm: 3 },
                              fontSize: { xs: '1.1rem', sm: '1.25rem' }
                            }}>
                              Thank You!
                            </Typography>
                            
                            <Typography variant="body1" sx={{ 
                              color: 'text.secondary', 
                              fontSize: { xs: '0.9rem', sm: '1rem' }, 
                              lineHeight: 1.6,
                              mb: 3
                            }}>
                              Our team will reach out to you soon via {formData.contactPreference === "text-me" ? "text message" : "email"}.
                            </Typography>

                            <Typography variant="body2" sx={{ 
                              color: 'text.secondary', 
                              fontSize: { xs: '0.75rem', sm: '0.875rem' }, 
                              lineHeight: 1.4,
                              mb: 3
                            }}>
                              If this is urgent, you can reach us directly at:
                            </Typography>
                          </Box>
                        )}
                      </Box>
                    )}

                    {/* Navigation Buttons */}
                    <Box sx={{ 
                      display: 'flex', 
                      justifyContent: 'space-between', 
                      mt: { xs: 2, sm: 3 },
                      gap: { xs: 1, sm: 2 }
                    }}>
                      <Button
                        variant="outlined"
                        onClick={prevStep}
                        disabled={currentStep === 1 || isLoading}
                        startIcon={<ChevronLeft />}
                        size="small"
                        sx={{
                          fontSize: { xs: '0.75rem', sm: '0.875rem' },
                          px: { xs: 1.5, sm: 2 },
                          py: { xs: 0.75, sm: 1 }
                        }}
                      >
                        Back
                      </Button>
                      
                      {currentStep < 4 ? (
                        <Button 
                          variant="contained" 
                          onClick={nextStep}
                          endIcon={<ChevronRight />}
                          size="small"
                          disabled={isLoading}
                          sx={{ 
                            bgcolor: '#E05C4B',
                            '&:hover': { bgcolor: '#d84315' },
                            fontSize: { xs: '0.75rem', sm: '0.875rem' },
                            px: { xs: 1.5, sm: 2 },
                            py: { xs: 0.75, sm: 1 }
                          }}
                        >
                          Next
                        </Button>
                      ) : currentStep === 4 ? (
                        <Button 
                          variant="contained" 
                          onClick={nextStep}
                          endIcon={<ChevronRight />}
                          size="small"
                          disabled={isLoading}
                          sx={{ 
                            bgcolor: '#E05C4B',
                            '&:hover': { bgcolor: '#d84315' },
                            fontSize: { xs: '0.75rem', sm: '0.875rem' },
                            px: { xs: 1.5, sm: 2 },
                            py: { xs: 0.75, sm: 1 }
                          }}
                        >
                          Next
                        </Button>
                      ) : currentStep === 5 ? (
                        <Button 
                          variant="contained" 
                          onClick={handleSubmit}
                          endIcon={isLoading ? <CircularProgress size={16} color="inherit" /> : <ChevronRight />}
                          size="small"
                          disabled={isLoading}
                          sx={{ 
                            bgcolor: '#E05C4B',
                            '&:hover': { bgcolor: '#d84315' },
                            fontSize: { xs: '0.75rem', sm: '0.875rem' },
                            px: { xs: 1.5, sm: 2 },
                            py: { xs: 0.75, sm: 1 }
                          }}
                        >
                          {isLoading ? "Processing..." : (formData.contactPreference === "call-now" ? "Call Now" : "Submit")}
                        </Button>
                      ) : currentStep === 6 && formData.contactPreference === "schedule-call" ? (
                        <Button 
                          variant="contained" 
                          onClick={handleSubmit}
                          endIcon={isLoading ? <CircularProgress size={16} color="inherit" /> : <ChevronRight />}
                          size="small"
                          disabled={isLoading}
                          sx={{ 
                            bgcolor: '#D14836',
                            '&:hover': { bgcolor: '#b91c1c' },
                            fontSize: { xs: '0.75rem', sm: '0.875rem' },
                            px: { xs: 1.5, sm: 2 },
                            py: { xs: 0.75, sm: 1 }
                          }}
                        >
                          {isLoading ? "Processing..." : "Schedule Call"}
                        </Button>
                      ) : currentStep === 6 && (formData.contactPreference === "text-me" || formData.contactPreference === "email-me") ? (
                        <Button 
                          variant="contained"
                          startIcon={<Phone />}
                          onClick={() => window.location.href = "tel:8333097030"}
                          size="small"
                          sx={{ 
                            bgcolor: '#D14836',
                            '&:hover': { bgcolor: '#b91c1c' },
                            fontSize: { xs: '0.75rem', sm: '0.875rem' },
                            px: { xs: 1.5, sm: 2 },
                            py: { xs: 0.75, sm: 1 }
                          }}
                        >
                          Call Now: (833) 352-0225
                        </Button>
                      ) : null}
                    </Box>
                  </CardContent>
                </Card>
              </Box>
            </Box>
          </Box>
        </Box>
      )}
    </Box>
    </>
  )
}
